module.exports = __webpack_public_path__ + "static/media/1POLICY49.48790f84.jpg";